import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  Autocomplete,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
import {
  getTaxCard,
  vendorTaxDetail,
  vendorTaxDetailForCnic,
} from "../../actions";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import "./style.css";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function TaxTable_Short_Import({
  formState,
  tempSetFormState,
  invoicePayload,
  disabled,
  invoiceTaxDetail_forImport_Inv,
  setInvoiceTaxDetail_forImport_Inv,
}) {
  const tableData = {
    taxId: 0,
    invoice_Id: 0,
    taxType: "",
    taxCode: "",
    amount: formState?.invoice_Amount,
    comments: "",
    created_By: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    taxCardId: 0,
  };
  const classes = useStyles();

  const [taxTableDropdownData, setTaxTableDropdownData] = useState({
    categories: [],
    purchaseType: [],
    supplierJurisdiction: [],
    supplierType: [],
    status: [],
    fillingStatus: [],
    goodsNature: [],
    taxType: [],
    taxCode: [],
  });

  const [taxCardLoading, setTaxCardLoading] = useState(false);
  const [taxCardData, setTaxCardData] = useState(false);

  const addInput = () => {
    setInvoiceTaxDetail_forImport_Inv((formState) => ({
      ...formState,
      invoice_TaxDetails: [...formState.invoice_TaxDetails, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoice_TaxDetails?.filter(
      (x, i) => i !== index
    );
    setInvoiceTaxDetail_forImport_Inv((formState) => ({
      ...formState,
      invoice_TaxDetails: filteredData,
    }));
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;
    let tempArray = invoiceTaxDetail_forImport_Inv?.invoice_TaxDetails;
    tempArray[index] = {
      ...invoiceTaxDetail_forImport_Inv?.invoice_TaxDetails[index],
      [name]: value,
    };

    setInvoiceTaxDetail_forImport_Inv((formState) => ({
      ...formState,
      invoice_TaxDetails: tempArray,
    }));
  };

  useEffect(() => {
    getTaxCard(setTaxTableDropdownData, setTaxCardLoading, setTaxCardData);
    // vendorTaxDetailForCnic(tempSetFormState,invoicePayload?.Vendor_Code,"setcount",formState)
    vendorTaxDetail(
      setTaxTableDropdownData,
      tempSetFormState,
      formState,
      invoicePayload?.Vendor_Code,
      invoicePayload?.Invoice_id,
      formState?.invoice_Amount,
      setTaxCardLoading
    );
  }, []);

  // FOR RE-USE the action(vendorTaxDetail) WE DO THIS
  // this is only used when invoice is created by import user.

  const autoCompleteChangeHandler = (name, newValue, index) => {
    let tempArray = invoiceTaxDetail_forImport_Inv.invoice_TaxDetails;
    tempArray[index] = {
      ...invoiceTaxDetail_forImport_Inv.invoice_TaxDetails[index],
      [name]: newValue,
    };
    setInvoiceTaxDetail_forImport_Inv((formState) => ({
      ...formState,
      invoice_TaxDetails: tempArray,
    }));
  };
  return (
    <div>
      <Grid container style={{ padding: "0px 5px" }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <TableContainer className="scrollable">
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Tax Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    WHT Code
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Base Amount
                  </TableCell>
                  {!disabled && (
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#031c30",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceTaxDetail_forImport_Inv?.invoice_TaxDetails?.length >
                  0 &&
                  invoiceTaxDetail_forImport_Inv?.invoice_TaxDetails?.map(
                    (item, index) => {
                      return (
                        <TableRow
                          key={index}
                          // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell sx={{ padding: "10px" }}>
                            <Autocomplete
                              id="selectedTaxCode"
                              options={taxTableDropdownData?.taxType}
                              size="small"
                              disabled={disabled}
                              value={{
                                taxType_v1: item?.taxType || "",
                                taxType:
                                  taxTableDropdownData?.taxType?.find(
                                    (x) => x?.taxType_v1 == item?.taxType
                                  )?.taxType || "",
                              }}
                              getOptionLabel={(option) =>
                                (option !== "" &&
                                  `${
                                    option?.TaxType || `${option?.taxType}`
                                  } `) ||
                                ""
                              }
                              // key={(option) => option?.taxType}
                              loading={taxCardLoading}
                              variant="standard"
                              onChange={(event, newValue) => {
                                autoCompleteChangeHandler(
                                  "taxType",
                                  newValue?.taxType_v1,
                                  index
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  name=""
                                  variant="standard"
                                  required
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell sx={{ padding: "10px" }}>
                            <Autocomplete
                              id=""
                              options={taxTableDropdownData?.taxCode}
                              size="small"
                              disabled={disabled}
                              value={{
                                taxCode_1: item?.taxCode || "",
                                taxCode:
                                  taxTableDropdownData?.taxCode?.find(
                                    (x) => x?.taxCode_1 == item?.taxCode
                                  )?.taxCode || "",
                              }}
                              getOptionLabel={(option) =>
                                (option !== "" &&
                                  `${option?.TaxCode || option?.taxCode}`) ||
                                ""
                              }
                              // key={(option) => option?.TaxCode}
                              loading={taxCardLoading}
                              variant="standard"
                              onChange={(event, newValue) => {
                                autoCompleteChangeHandler(
                                  "taxCode",
                                  newValue?.taxCode_1,
                                  index
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  name=""
                                  variant="standard"
                                  required
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell sx={{ padding: "10px" }}>
                            <TextField
                              type="number"
                              size="small"
                              fullWidth
                              variant="standard"
                              disabled={disabled}
                              name="amount"
                              value={item?.amount || item?.Amount || ""}
                              onChange={(event) => changeHandler(event, index)}
                            />
                          </TableCell>
                          {!disabled && (
                            <TableCell align="center">
                              <Delete
                                color="error"
                                onClick={() => {
                                  deleteInput(index);
                                }}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </Table>
            {invoiceTaxDetail_forImport_Inv?.invoice_TaxDetails?.length ===
            0 ? (
              <EmptyData />
            ) : (
              ""
            )}
          </TableContainer>
          {!disabled && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TaxTable_Short_Import;
